import 'view/css/mg-customer.css';

import { useState } from 'react';

import API from 'service/api';
import Loading from 'component/Loading';
import PopMessage from 'component/pop-msg/PopMessage';

import SearchCustomerTable from 'component/SearchCustomerTable';

const SplitCustView = (props) => {

  const [loading, setLoading] = useState(false);

  const [sr_name, setSearchCustomerName] = useState('');
  const [sr_contact, setSearchContact] = useState('');
  const [sr_license, setSearchLicense] = useState('');
  const [sr_cust_rslt, setSearchResult] = useState(null);

  const [sel_cust, setCustomer] = useState(null);

  const search = () =>
  {
    setLoading(true);
    let dto = {
      name: sr_name,
      contact: sr_contact,
      license: sr_license,
    };
    API.searchCustomer(dto).then(resp => {
      if (!resp.success)
        PopMessage.show(resp.msg, '失敗', 'danger');
      else {
        setSearchResult(resp.msg);
      }
      setLoading(false);
    });
  }

  const toggleSelect = (vehicle, selected) =>
  {
    vehicle.selected = selected;
    setCustomer({...sel_cust});
  }

  const split = () => {
    let sv = sel_cust.vehicles.filter(x => x.selected).map(v => v.cd_license);
    if (0 == sv.length) {
      PopMessage.show('請選擇欲分拆車輛。', '警告', 'danger');
      return false;
    } else {
      API.splitCustomer(sv).then(resp => {
        if (resp.success)
        {
          setCustomer(null);
          setSearchResult(null);
          PopMessage.show('已分拆客戶', '成功', 'success');
        } else {
          PopMessage.show('操作失敗', '失敗', 'danger');
        }
      });
    }
  }

  return (<>
    <h1>其他管理 - 分拆客戶</h1>
    <div className="split-cust-view">
    { !!sel_cust &&
      <div className="sp-list box">
        <h4 className="box-head">已選取客戶 - { sel_cust.display_name }</h4>
        <div className="box-body">
          <table className="data-table full-width">
            <colgroup>
              <col width="30px" />
              <col width="auto" />
            </colgroup>
            <thead>
              <tr>
                <th>選取</th>
                <th>車牌</th>
              </tr>
            </thead>
            <tbody>
              { sel_cust.vehicles.map(v =>
                <tr key={v.cd_license}>
                  <td>
                    <input type="checkbox" value={v.selected} onChange={e=>toggleSelect(v, e.target.checked)} />
                  </td>
                  <td>
                    { v.cd_license }
                  </td>
                </tr>
              )}
            </tbody>
          </table>
          <div className="action-panel">
            <span className="dummy"></span>
            <button className="btn red" onClick={split}>分拆至新客戶</button>
          </div>
        </div>
      </div>
    }
      <div className="sp-search box">
        <h4 className="box-head">搜尋客戶</h4>
        <div className="box-body">
          <div className="action-panel">
            <div className="row">
              <label className="field">
                <strong>客戶名稱</strong>
                <input type="text" value={sr_name} onChange={e=>setSearchCustomerName(e.target.value)} />
              </label>
              <label className="field">
                <strong>電話或電郵</strong>
                <input type="text" value={sr_contact} onChange={e=>setSearchContact(e.target.value)} />
              </label>
              <label className="field">
                <strong>車牌</strong>
                <input type="text" value={sr_license} onChange={e=>setSearchLicense(e.target.value)} />
              </label>
            </div>
            <div>
              <button className="btn blue" onClick={search}>搜尋</button>
            </div>
          </div>
          <div>
          { loading
            ? <Loading />
            : <SearchCustomerTable text="選擇"
                items={sr_cust_rslt} onSelect={setCustomer}/>
          }
          </div>
        </div>
      </div>
    </div>
  </>);

}

export default SplitCustView;
